import React from "react"
import styled from "@emotion/styled"

const Container = styled.div`
  max-height: 300px;
  overflow: hidden;
  position: relative;
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    margin: 0 -2rem; 
  }
`

const Title = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 1rem;
  position: absolute;
  padding: 1rem;
  z-index: 1;
  opacity: 1;
  top: 40%;
  transform: translateY(-50%);
  width: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  h1 {
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 10px;
    font: 400 45px ${props => props.theme.fonts.serif};
    color: ${props => props.theme.colors.primary};
    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      font: 400 30px ${props => props.theme.fonts.serif};
      letter-spacing: 3px;
    }
    @media (max-width: ${props => props.theme.breakpoints.phone}) {
      font: 400 20px ${props => props.theme.fonts.serif};
      letter-spacing: 3px;
    }
  }
  h2 {
    margin: 0;
    font: 100 20px ${props => props.theme.fonts.serif};
    color: ${props => props.theme.colors.secondary};
  }
  @media (max-width: ${props => props.theme.breakpoints.phone}) {
    padding: 0.5rem;
  }
`

const Splash = ({ children, title, subtitle }) => (
  <>
    <Container>
      {children}
      {(title || subtitle) && (
        <Title>
          {title && <h1>{title}</h1>}
          {subtitle && <h2>{subtitle}</h2>}
        </Title>
      )}
    </Container>
  </>
)

export default Splash
